<template>
  <div>
    <div class="text-center">
      <v-text-field
        v-model="cardFilterStore.filter.search"
        variant="solo"
        density="compact"
        :width="219"
        bg-color="white"
        class="d-inline-block"
      >
        <template #prepend-inner>
          <font-awesome-icon
            :icon="['fas', 'search']"
          />
        </template>
      </v-text-field>
      <v-btn
        color="primary"
        height="40px"
        class="vertical-align-top ml-2"
        @click.stop="openFilterDrawer"
      >
        <font-awesome-icon
          :icon="['fas', 'sliders-h']"
          class="mr-2"
        />
        {{ $t('filter_menu.filter') }}
      </v-btn>
    </div>
    <div class="text-center">
      <v-switch
        v-model="cardFilterStore.filter.property.isPlayingGw"
        dense
        :label="$t('filter_menu.playing_this_gw')"
        class="d-inline-block mx-2 my-0"
      />
      <v-switch
        v-model="showLastScores"
        dense
        :label="$t('filter_menu.show_last_5_score')"
        class="d-inline-block mx-2 my-0"
        @change="toggleLastScores"
      />
    </div>
    <filter-drawer v-model="displayFilterDrawer" />
  </div>
</template>

<script>
import FilterDrawer from '@/components/Card/Filter/FilterDrawer.vue';
import { useCardFilterStore } from '@/store/cardFilter.module';

export default {
  name: 'FilterMenu',
  components: {
    FilterDrawer,
  },
  setup() {
    const cardFilterStore = useCardFilterStore();

    return { cardFilterStore };
  },
  data() {
    return {
      displayFilterDrawer: false,
      showLastScores: false,
    };
  },
  methods: {
    openFilterDrawer() {
      this.displayFilterDrawer = true;
    },
    toggleLastScores() {
      this.$emit('toggleLastScores', this.showLastScores);
    },
  },
};
</script>
